import { Button } from '@mui/material';
import Excel from 'exceljs';
import FileSaver from 'file-saver';
import React from 'react';
import { ProductionSummaryPageQuery } from '../../../../services';
import dayjs from 'dayjs';

export function EmployeeSummaryExportButton({
    employees,
    disabled,
    resources,
}: {
    employees?: ProductionSummaryPageQuery['getEmployeeSummary']['Employees'];
    resources?: ProductionSummaryPageQuery['getProductionResourcesSummary']['ProductionResources'];
    disabled: boolean;
}) {
    return (
        <Button
            disabled={disabled}
            onClick={async () => {
                const workbook = new Excel.Workbook();
                const employeeWs = workbook.addWorksheet('Empleados');
                employeeWs.addRow([
                    'Año',
                    'Mes',
                    'Mes (#)',
                    'Dia',
                    'Horas',
                    'Empleado',
                    'Producto',
                    'Maquina',
                    'Kilos',
                    'Bultos',
                ]);
                employees?.forEach((employee, index) => {
                    employeeWs.addRow([
                        employee.year,
                        employee.month !== null && employee.month !== undefined
                            ? dayjs()
                                  .set('month', employee.month - 1)
                                  .format('MMMM')
                            : '',
                        employee.month,
                        employee.day,
                        employee.hours,
                        employee.employee_name,
                        employee.product_name,
                        employee.machine_name,
                        employee.kilos,
                        employee.groups,
                    ]);
                });

                const resourcesWs = workbook.addWorksheet('Recursos');
                resourcesWs.addRow([
                    'Año',
                    'Mes',
                    'Mes (#)',
                    'Dia',
                    'Empleado',
                    'Producto',
                    'Maquina',
                    'Kilos',
                    'Grupos',
                    'Horas',
                ]);
                resources?.forEach((resource, index) => {
                    resourcesWs.addRow([
                        resource.year,
                        resource.month !== null && resource.month !== undefined
                            ? dayjs()
                                  .set('month', resource.month - 1)
                                  .format('MMMM')
                            : '',
                        resource.month,
                        resource.day,
                        resource.employee_name,
                        resource.product_name,
                        resource.machine_name,
                        resource.kilos,
                        resource.groups,
                        resource.hours,
                    ]);
                });

                const buffer = await workbook.xlsx.writeBuffer();

                FileSaver.saveAs(new Blob([buffer]), 'empleados.xlsx');
            }}
        >
            Descargar resumen de empleados
        </Button>
    );
}
